import * as dc from "@/components/layout/list/defaultType";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import { defaultFloatFomatter, getInputValueCheck, getMatchingData, runFormFunction, setFormClass } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { DataCols, DataColumnField, DataColumnRecord } from "../../input/inputType";
import { getTranslate } from "@/util/arrayutil";
import { exportElementAsPNGDefault } from "@/util/fileutil";
import {
  cupnoteListCommon,
  qcCommonCols,
  qcCommonInit,
  qcFlavorwheelChart,
  qcFlavorwheelList,
  qcFlavorwheelReverse,
  qcFlavorwheelRotate,
  qcFlavorwheelSet,
  qcFlavorwheelSimple,
  qcRadar,
} from "../../inputCols/qcCols";
import { beaninfoGreenbeanCol, beaninfoGreenbeanList, beaninfoLossCols, beaninfoNameCols } from "../../inputCols/beaninfoCols";
import { brewingChangeCalc, brewingCommon, brewingDefault, brewingInit, brewingSteps, brewingType } from "../../inputCols/brewingCols";
import { roastingProfileCols } from "../../inputCols/roastingCols";
import { isSafari } from "react-device-detect";
import { roastingProfileClipboard } from "../../inputCols/clipboard";
import { Capacitor } from "@capacitor/core";
import { AppDownloadBlank, fileSaved, fileSaveError } from "@/util/apputil";
import { enLocale } from "@/i18n/routing";
export const UserChart = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;
  const message = props.message;
  // const { message } = App.useApp();

  const saveAlert = fileSaved(alertContext, ta);
  const saveErrorAlert = fileSaveError(alertContext, ta);

  const utcOffset = dayjs().utcOffset() * 60000;

  const brewing_record_test_buttons: DataColumnField = {
    label: "blank",
    itemClassName: "DownloadHidden mb-4",
    fieldId: {
      brewing_record_samples: {
        inputType: "element",
        elementProp: {
          element: "sample_value_input",
          elementType: "button",
          transition: true,
          buttonProp: {
            onClick: () => {
              const temp_data = getMatchingData(form?.current, formMemo?.current, dc.tempBrewingData);
              Debug(temp_data);
              form?.current?.setFieldsValue(temp_data);
              brewingInit(form?.current, formFunction?.current, dataFunction?.current, temp_data, params?.setTimer);
              // brewingChangeCalc(form?.current);
            },
          },
        },
        saveData: false,
      },
      brewing_record_clear: {
        inputType: "element",
        inputClassName: "input_ml",
        elementProp: {
          element: "clear_label",
          elementType: "button",

          transition: true,
          buttonProp: {
            className: "input_ml",
            onClick: () => {
              const temp_data: Record<string, any> = { brewing_step_use: false };
              dc.tempBrewingClearDataFields.forEach((key) => (temp_data[key] = undefined));
              form?.current?.setFieldsValue(temp_data);
              brewingInit(form?.current, formFunction?.current, dataFunction?.current, temp_data, params?.setTimer);
            },
          },
        },
        saveData: false,
      },
    },
  };

  switch (params?.page.page ?? "") {
    case "Intro":
      return {
        ...result,
        dataName: "Intro",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        saveButton: false,
        cancelButton: false,
        clipboard: {
          category: "QCCommon",
          exField: ["roaster_seq", "cupnote_seq", "intro_desc"],
          front: false,
          load: (data) => {
            [
              "cupnote_balance_point",
              "cupnote_aroma_point",
              "cupnote_sweetness_point",
              "cupnote_body_point",
              "cupnote_flavor_point",
              "cupnote_acidity_point",
            ].forEach((item) => runFormFunction(formFunction?.current, item, "inputSync"));
            runFormFunction(formFunction?.current, "cupnote_radar", "changeData");
          },
        },
        timer: dc.brewingTimer,
        dataInit: (data: any) => {
          Debug("Intro init", data);
          if (params?.setTimer) {
            params.setTimer({ timer: dc.brewingTimer, start: undefined });
          }
          setTimeout(() => {
            setFormClass(dataFunction?.current, {
              hidden_step_detail: !(data["brewing_step_use"] === 1),
            });
            brewingChangeCalc(form?.current, dataFunction?.current);
            const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
            if (objs && objs.length > 0) {
              runFormFunction(formFunction?.current, "cupnote_flavor_wheel", "changeData");
              const rotate =
                getInputValueCheck(form?.current, formMemo?.current, dataFunction?.current, data, "cupnote_flavor_wheel_rotate") ?? 0;
              Debug("qcCommonInit", rotate);
              const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
              objs.forEach((g) => {
                const obj = g as SVGGElement;
                const ctm = getTranslate(obj);
                if (ctm) {
                  obj.setAttribute("transform", `translate(${ctm.x}, ${ctm.y}) rotate(${rotate})`);
                }
              });
            }
          }, dc.setTimeoutDelay);
        },
        dataCols: {
          intro_desc: {
            // ...dc.textArea,
            inputType: "display",
            // ...dc.labelHidden,
            // itemClassName: "mb-4",
            // label: "blank",
            labelClassName: dc.strongLabelClassName + " DownloadInvisible",
            saveData: false,
            variant: "borderless",
            edit: { showCount: false },
            readOnly: true,
            noItem: false,
            valueStyle: { resize: "none", fontSize: "1.2rem", fontWeight: "bold" },
            textAreaProp: {
              rows: props.isMobile ? (params?.locale === enLocale ? 9 : 7) : 4,
              style: { resize: "none", fontSize: "1.2rem", fontWeight: "bold", textAlign: "center", height: "auto" },
            },
          },
          // site_qrcode: {
          //   ...dc.qrcode,
          //   label: "blank",
          //   edit: { display: true },
          //   fixedValue: `https://coffeein.site/`,
          //   linkOption: { useHost: false },
          // },
          div_1: dc.itemDiv,
          ...qcFlavorwheelReverse(formFunction?.current),
          ...qcFlavorwheelSet(formFunction?.current, alertContext, ta),
          cupnote_flavor_list: {
            ...qcFlavorwheelList(formFunction?.current),
          },
          cupnote_aftertaste_list: { ...cupnoteListCommon, codeGroup: "CNAFTST" },
          cupnote_texture_list: { ...cupnoteListCommon, codeGroup: "CNTXTR" },
          cupnote_feeling_list: { ...cupnoteListCommon, codeGroup: "CNFLNG" },
          div_2: dc.itemDiv,
          brewing_record_test_buttons,
          brewing_grinder_setting: {
            labelClassName: dc.strongLabelClassName,
            itemClassName: "brewing_result",
            fieldId: {
              brewing_bean_mass: { ...dc.mass, variant: "outlined", tooltip: "bean_mass", placeholder: "bean_mass" },
              brewing_grinder_point: {
                ...dc.number2f,
                variant: "outlined",
                tooltip: "grinder_point",
                placeholder: "grinder_point",
                formatter: defaultFloatFomatter,
                inputClassName: dc.inputNumberClassName,
              },
            },
          },
          ...brewingSteps(t, form, formMemo?.current, formFunction?.current, dataFunction?.current, params?.setTimer, false, false),
          div_3: dc.itemDiv,
          cupnote_name_locale: {
            ...dc.inputFull,
            display: params?.locale === enLocale ? false : undefined,
            noItem: false,
            saveData: false,
            onChange: () => {
              runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
            },
          },
          cupnote_name: {
            ...dc.inputFull,
            display: params?.locale !== enLocale ? false : undefined,
            noItem: false,
            saveData: false,
            onChange: () => {
              runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
            },
          },
          ...qcRadar(formFunction?.current, [params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale"], "Coffee"),
        },
        tempValue: {
          intro_desc:
            params?.locale === enLocale ? (
              <>
                This is a app for easily recording and sharing coffee brewing and roasting information.
                <br />
                On the current screen, you can try out the basic yet essential features directly.
                <br />
                Each feature is also available separately in the chart menu.
                <br />
                Additional recording options are available after sign in with Google.
              </>
            ) : (
              <>
                커피 추출과 로스팅 관련 정보를 쉽게 기록하고 공유하기 위한 앱입니다.
                <br />
                현재 화면에는 기본적이면서 핵심기능을 직접 사용해볼수 있습니다.
                <br />
                또한 각 기능들은 메뉴의 차트에서 별도로 사용 가능합니다.
                <br />그 외 기능은 로그인 후 사용 가능합니다.
              </>
            ),
          cupnote_name_locale: "원두이름을 넣으세요.",
          cupnote_name: "Coffee Bean",
          site_qrcode: `https://coffeein.site`,
          ...dc.tempBrewingData,
        },
        hiddenAds: true,
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_user","system_table_pk":["roaster_seq","roaster_user_seq"],"system_table_page":"RoasterUser","system_table_path":"roaster/user/list","system_table_page_name":"RoasterUser","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roasteruser","system_table_detail_result":"detail_result","system_table_search_column":["roaster_user_auth","roaster_user_use"],"system_table_search_select":["roaster_user_name","roaster_user_nick"],"system_table_order_column":["roaster_user_auth","roaster_user_nick","roaster_user_name","rgst_at"],"system_table_default_name_column":"roaster_user_name","system_table_use_column":"roaster_user_use"}
    //--info--}
    case "Flavorwheel":
      return {
        ...result,
        dataName: "FlavorwheelData",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        saveButton: false,
        cancelButton: false,
        clipboard: {
          category: "QCCommon",
          exField: ["roaster_seq", "cupnote_seq"],
          load: (data) => {},
        },
        dataCols: {
          ...qcFlavorwheelChart,
          cupnote_flavor_list: {
            ...qcFlavorwheelList(formFunction?.current),
            // itemClassName: "hidden",
          },
          ...qcFlavorwheelRotate(alertContext, ta),
          ...qcFlavorwheelSimple(formFunction?.current),
          ...qcFlavorwheelReverse(formFunction?.current),
        },
        hiddenAds: false,
      };
    case "CoffeeCountry":
      return {
        ...result,
        dataName: "CoffeeCountryData",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        saveButton: false,
        cancelButton: false,
        // clipboard: {
        //   category: "QCCommon",
        //   exField: ["roaster_seq", "cupnote_seq"],
        //   load: (data) => {},
        // },
        dataCols: {
          blending_country_list: {
            ...dc.coffee_country,
            // selectFilter: undefined,
            noItem: false,
            readInput: true,
            readInputDisabled: true,
            label: "country_label",
            inputType: "selectSearch",
            // selectProp: { mode: "multiple" },
            onChange: (e) => {
              Debug(e);
              const values =
                e.value instanceof Array && e.value.length > 0 ? e.value[e.value.length - 1] : e.value !== undefined ? [e.value] : [];
              runFormFunction(formFunction?.current, "blending_country_map", "setSelectCountry", values);
            },
          },
          blending_country_list_guide: { ...dc.guideDefault, fixedValue: "blending_country_list_guide", guide: false },
          blending_country_map: {
            ...{ ...dc.geoMapChart, geoMapProp: { ...dc.geoMapChart.geoMapProp, mapDisplay: true, select_country: [], mapRescale: true } },
            indexKey: "blending_country_list",
            onClick: (e) => {
              Debug(e);
            },
            // indexLabelKey: locale !== enLocale ? "country_name" : "country_nick",
          },
        },
        hiddenAds: false,
      };
    case "RadarChart":
      return {
        ...result,
        dataName: "RadarChartData",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        saveButton: false,
        cancelButton: false,
        clipboard: {
          category: "QCCommon",
          exField: ["roaster_seq", "cupnote_seq"],
          load: (data) => {
            // Debug(data);
            [
              "cupnote_balance_point",
              "cupnote_aroma_point",
              "cupnote_sweetness_point",
              "cupnote_body_point",
              "cupnote_flavor_point",
              "cupnote_acidity_point",
            ].forEach((item) => runFormFunction(formFunction?.current, item, "inputSync"));
            runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
          },
        },
        dataInit: () => {
          runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
          runFormFunction(formFunction?.current, "cupnote_radar", "changeData");
        },
        dataCols: {
          cupnote_name_locale: {
            ...dc.inputFull,
            display: params?.locale === enLocale ? false : undefined,
            noItem: false,
            saveData: false,
            onChange: () => {
              runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
            },
          },
          cupnote_name: {
            ...dc.inputFull,
            display: params?.locale !== enLocale ? false : undefined,
            noItem: false,
            saveData: false,
            onChange: () => {
              runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
            },
          },
          ...qcRadar(formFunction?.current, [params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale"], "Coffee"),
        },
        hiddenAds: true,
        tempValue: { cupnote_name_locale: "원두이름을 넣으세요.", cupnote_name: "Coffee Bean" },
      };
    case "BrewingRecord":
      return {
        ...result,
        dataName: "BrewingRecordData",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        saveButton: false,
        cancelButton: false,
        clipboard: {
          category: "BrewingCommon",
          exField: ["roaster_seq", "cupnote_seq", "brewing_start_time"],
          load: (data) => {},
        },
        timer: dc.brewingTimer,
        dataInit: (data: any) => brewingInit(form?.current, formFunction?.current, dataFunction?.current, data, params?.setTimer),
        dataCols: {
          brewing_record_desc: {
            ...dc.textArea,
            itemClassName: "mb-4",

            label:
              isSafari || Capacitor.getPlatform() === "ios" || AppDownloadBlank()
                ? "blank"
                : {
                    element: Capacitor.isNativePlatform() ? "share_image" : "download_image",
                    elementType: "button",
                    transition: true,
                    buttonProp: {
                      onClick: () => {
                        exportElementAsPNGDefault(ta, alertContext, "form#BrewingRecordData_Form.ant-form", "BrewingRecord", undefined);
                      },
                    },
                  },
            labelUse: isSafari ? false : undefined,
            valueStyle: isSafari ? { gridColumn: "1 / span 2" } : undefined,

            labelClassName: "DownloadInvisible",
            saveData: false,
            variant: "borderless",
            edit: { showCount: false },
            textAreaProp: { rows: 4 },
          },
          brewing_record_test_buttons,

          // brewing_grinder_setting: {
          //   labelClassName: dc.strongLabelClassName,
          //   itemClassName: "brewing_result",
          //   fieldId: {
          //     brewing_bean_mass: { ...dc.mass, variant: "outlined", tooltip: "bean_mass", placeholder: "bean_mass" },
          //     brewing_grinder_point: {
          //       ...dc.number2f,
          //       variant: "outlined",
          //       tooltip: "grinder_point",
          //       placeholder: "grinder_point",
          //       formatter: defaultFloatFomatter,
          //       inputClassName: dc.inputNumberClassName,
          //     },
          //   },
          // },
          // ...brewingSteps(t, form, formMemo?.current, formFunction?.current, dataFunction?.current, true, params?.setTimer),

          ...brewingDefault(
            t,
            form,
            formMemo?.current,
            formFunction?.current,
            dataFunction?.current,
            params?.setTimer,
            params?.locale,
            "user",
            "demo",
            false,
          ),
        },
        tempValue: {
          brewing_step_use: 1,
          brewing_record_desc:
            params?.locale === enLocale
              ? "A simple brewing timer.\r\nEnter the input amount for each stage, and the weight for each stage will be calculated.\r\nPress the clock button to start the timer.\r\nYou can record the time for each stage by pressing the corresponding clock button."
              : "간단한 추출 타이머입니다.\r\n단계별 투입량을 입력하면 단계별 무게가 계산됩니다.\r\n추출시작의 시계버튼을 눌르면 타이머가 작동합니다.\r\n단계별 시계버튼을 눌러 타이머의 시간을 기록할 수 있습니다.",
        },
        hiddenAds: false,
      };
    case "RoastingProfile":
      return {
        ...result,
        dataName: "RoastingProfileData",
        dataFormClassName: "roasting_profile_use",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        saveButton: false,
        cancelButton: false,
        undoButton: true,
        clipboard: roastingProfileClipboard,
        timer: "roasting_start_time",
        dataInit: (data: any) => {
          form?.current?.setFieldsValue({ timeline_chart: true });
        },
        dataCols: {
          roasting_profile_desc: {
            inputType: "element",
            elementProp: {
              element: "sample_value_input",
              elementType: "button",
              transition: true,
              buttonProp: {
                onClick: () => {
                  const temp_data = getMatchingData(form?.current, formMemo?.current, dc.tempTimelineData);
                  form?.current?.setFieldsValue({ ...temp_data, timeline_chart: true });
                },
              },
            },
            itemClassName: "mb-4",
            label: "blank",
            // AppDownloadBlank() ? "blank": {
            //   element: Capacitor.isNativePlatform() ? "share_image" : "download_image",
            //   elementType: "button",
            //   transition: true,
            //   buttonProp: {
            //     onClick: () => {exportElementAsPNGDefault(ta,alertContext,"form.ant-form .rt-Flex.data-chart.TimelineChart","RoastingProfile",undefined,);},
            //   },
            // },
            // labelClassName: "DownloadInvisible",
          },
          ...roastingProfileCols(
            form,
            formFunction?.current,
            formMemo?.current,
            dataFunction?.current,
            params?.locale,
            params?.setTimer,
            t,
            message,
            props.isMobile,
          ),
        },
        hiddenAds: false,
      };
    default:
      return undefined;
  }
};
